// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2oM4q","col":"styles_col__34FtB"};